import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import useErrorReporting from "./errorReportingService";


const ReportingErrorBoundary = ({ children }) => {

  const { sendError } = useErrorReporting();

  const reportError = (error, info) => {
    sendError(error);
  };

  
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={reportError}>
      {children}
    </ErrorBoundary>
  );

};

export default ReportingErrorBoundary;